import React from "react";
import { Modal, ModalBody } from "reactstrap";

interface ModalProps {
    isActive: boolean;
    onClose: () => void;
    disableBackdropClick?: boolean,
    headerRightComponent?: React.ReactNode
    description?: React.ReactNode,
    remount?: boolean
}

type InModalOptions = {
    id?: string
    dialogClassName?: string
    modalClassName?: string
    centered?: boolean
    scrollable?: boolean
    modalBodyClassName?: string
    modalHeaderClassName?: string
}

const inModal = <P extends object>(
    WrappedComponent: React.ComponentType<P>,
    title: string,
    options: InModalOptions = {}
) => {
    const {
        id = 'milestone-modal',
        dialogClassName,
        modalClassName,
        centered = true,
        scrollable = false,
        modalBodyClassName = '',
        modalHeaderClassName = '',
    } = options

    const MilestoneOffcanvas: React.FC<P & ModalProps> = ({
        isActive,
        disableBackdropClick = false,
        onClose,
        headerRightComponent,
        description,
        remount = true,
        ...props
    }) => {

        const onBackDropClick = () => {
            if (disableBackdropClick) return;
            onClose();
        }

        return (
            <Modal
                centered={centered}
                scrollable={scrollable}
                isOpen={isActive}
                toggle={onClose}
                id={id}
                className={dialogClassName}
                modalClassName={modalClassName}
            >
                <div className={`modal-header ${modalHeaderClassName}`}>
                    {headerRightComponent ? (
                        <div className="d-flex align-items-start justify-content-between gap-2 w-100">
                            <div className="flex-grow-1 min-w-0">
                                {title ? <h4 className="modal-title">{title}</h4> : null}
                                {description}
                            </div>
                            {headerRightComponent}
                        </div>
                    ) : (
                        <div className="d-flex flex-column">
                            {title ? <h4 className="modal-title">{title}</h4> : null}
                            {description}
                        </div>
                    )}
                </div>
                <ModalBody className={modalBodyClassName}>
                    {
                        remount ? (
                            <>
                                {
                                    isActive && <WrappedComponent isActive={isActive} {...(props as P)} onClose={onClose} />
                                }
                            </>
                        ) : (
                            <WrappedComponent isActive={isActive} {...(props as P)} onClose={onClose} />
                        )
                    }
                </ModalBody>
            </Modal>
        );
    };

    return MilestoneOffcanvas;
};

export default inModal;